import { oktaAuth } from '../../app/oktaAuth';
import { clearTenantSessionStorage } from '../tenantSession';

let logoutInProgress = false;

// Single source of truth for ending a user session — used by the manual
// Logout button in Header and by the 401 interceptor in API containers.
// Clears app-owned localStorage keys, calls Okta signOut so the SSO session
// ends server-side, and falls back to a hard navigation if signOut throws.
// The logoutInProgress flag prevents concurrent calls (e.g. several 401s
// firing at once) from stacking redirects.
export const forceLogoutToLogin = async (): Promise<void> => {
    if (logoutInProgress) {
        return;
    }
    logoutInProgress = true;

    localStorage.removeItem('userRole');
    localStorage.removeItem('userDetails');
    localStorage.removeItem('userDetailsEUM');
    clearTenantSessionStorage();

    try {
        await oktaAuth.signOut({
            postLogoutRedirectUri: `${window.location.origin}/logout`
        });
    } catch {
        window.location.assign(`${window.location.origin}/logout`);
    }
};
